
const ExecutionEntryCanceled = () => {
  return (
    <>

    </>
  );
}

export default ExecutionEntryCanceled;
